"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Button_1 = __importDefault(require("@/components/Button"));
const AssociateProductTitle_1 = __importDefault(require("@/pages/Products/components/AssociateProductTitle"));
const CreateProductsAssociationTable_1 = __importDefault(require("../CreateProductsAssociationTable"));
const style_1 = require("./style");
function AssociateProductsSectionView({ onAssignComponent, shouldShowComponentTable, isExistingAssociation, }) {
    const shouldShowNoComponentsSection = !isExistingAssociation && !shouldShowComponentTable;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true, style: { height: "100%" } },
            react_1.default.createElement(AssociateProductTitle_1.default, null)),
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true },
            shouldShowNoComponentsSection && (react_1.default.createElement(style_1.ContentWrapper, null,
                "This product does not contain any components yet. Click the button below to add components.",
                react_1.default.createElement(Button_1.default, { label: "Assign Component", color: "secondary", onClick: onAssignComponent, variant: "outlined" }))),
            !shouldShowNoComponentsSection && react_1.default.createElement(CreateProductsAssociationTable_1.default, null))));
}
exports.default = AssociateProductsSectionView;
